import { useFpCampaignProductsService } from '@cart-services/hooks/useFpCampaignProductsService'
import { type CountryCode, type ProjectCode } from '@constants'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { useRef } from 'react'
import ChildClientPrivacyPolicy from '../../components/child-client-privacy-policy'
import { TheCampaignHeader } from '../../components/TheCampaignHeader'
import style from '../../style/pages/client-privacy-policy.module.scss'
import { loadPrivacyPolicyClientData } from '../client-data-import'
import { useProductCatalog } from './product-catalog/components/ProductCatalogProvider/useProductCatalog'

const ClientPrivacyPolicy = () => {
  const { campaignCode } = useProductCatalog()
  const { destructuredData: exhibitorSettings } = useApiCampaignActivityInfo(campaignCode)
  const campaignId = exhibitorSettings?.campaign_id ?? undefined
  const { region: countryCode } = exhibitorSettings || {}
  const { projectCode } = useFpCampaignProductsService(campaignCode)
  const country = exhibitorSettings?.region.toLowerCase() || 'hk'
  const policy = useRef<PrivacyPolicy.PrivacyData>(loadPrivacyPolicyClientData(country))
  return (
    <main className={style.main}>
      <TheCampaignHeader projectCode={projectCode as ProjectCode} campaignId={campaignId as number} countryCode={countryCode as CountryCode} />
      <div className={style.wrapper}>
        <div className={style['main-title']}>{policy.current?.mainTitle}</div>
        <div className={style['main-text']}>{policy.current?.mainText}</div>
        {policy.current?.mainContent.map(item => (
          <ChildClientPrivacyPolicy key={item.title} data={item} />
        ))}
      </div>
    </main>
  )
}

export default ClientPrivacyPolicy
